import { push } from 'connected-react-router'
import { useIntl } from 'react-intl'
import { Button, CardActions, CardText, CardTitle } from 'react-md'
import { useDispatch } from 'react-redux'
import type { Manager } from 'types/manager'
import LoadingState from 'ui/components/LoadingState'
import { getHTJ2SystemAuthorizationUrl } from 'ui/ManagerHTJ2SystemAuthorization/utils'
import { StandardCard } from 'ui/StyledComponents/Cards'
import { useHTJ2Authorization } from './useHTJ2Authorization'

const HTJ2AuthorizationCard = ({
	selectedManager,
	context,
}: {
	selectedManager: Manager | null | undefined
	context: 'user' | 'manager'
}) => {
	const intl = useIntl()
	const dispatch = useDispatch()
	const managerUUID = selectedManager?.uuid

	const { loading, error, authKeyWorks } = useHTJ2Authorization(
		managerUUID,
		undefined,
		context,
	)

	const handleSystemAuthorizationClick = () => {
		dispatch(push(`/manager/htj2_system_authorization/${context}`))
	}

	let pageContent
	if (loading || !managerUUID) {
		pageContent = (
			<>
				<CardText>
					<LoadingState />
				</CardText>
			</>
		)
	} else if (error) {
		pageContent = (
			<>
				<CardText>
					{intl.formatMessage({
						defaultMessage:
							'Järjestelmäluvituksen tarkistamisessa tapahtui virhe, yritä uudelleen myöhemmin.',
						description:
							'An error occurred while checking system authorization, try again later.',
					})}
				</CardText>
				<CardActions>
					<Button flat secondary onClick={() => window.location.reload()}>
						{intl.formatMessage({
							defaultMessage: 'Päivitä sivu',
							description: 'Refresh the page',
						})}
					</Button>
				</CardActions>
			</>
		)
	} else if (authKeyWorks) {
		pageContent = (
			<>
				<CardText>
					<div
						style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
					>
						<p>
							{intl.formatMessage({
								defaultMessage: 'HTJ2 järjestelmäluvitus on myönnetty.',
								description: 'HTJ2 system authorization granted.',
							})}
						</p>
						<p>
							{intl.formatMessage({
								defaultMessage:
									'Voit tarvittaessa siirtyä hallinnoimaan järjestelmäluvituksia Maanmittauslaitoksen sivuille.',
								description:
									'You can go to system authorization management on MML website if needed.',
							})}
						</p>
					</div>
				</CardText>
				<CardActions>
					<Button
						flat
						secondary
						onClick={() =>
							(window.location.href = getHTJ2SystemAuthorizationUrl())
						}
					>
						{intl.formatMessage({
							defaultMessage: 'Siirry hallinnoimaan järjestelmäluvituksia',
							description: 'Go to system authorization management',
						})}
					</Button>
				</CardActions>
			</>
		)
	} else {
		pageContent = (
			<>
				<CardText>
					{intl.formatMessage({
						defaultMessage:
							'Voit ottaa HTJ2-integraation käyttöön tekemällä järjestelmäluvituksen.',
						description:
							'You can enable the HTJ2 integration by performing system authorization.',
					})}
				</CardText>
				<CardActions>
					<Button flat secondary onClick={handleSystemAuthorizationClick}>
						{intl.formatMessage({
							defaultMessage: 'Tee järjestelmäluvitus',
							description: 'Perform system authorization',
						})}
					</Button>
				</CardActions>
			</>
		)
	}

	return (
		<>
			<StandardCard
				className="margin-bottom full-width"
				style={authKeyWorks ? { background: 'rgb(240,255,240)' } : {}}
			>
				<CardTitle
					title={intl.formatMessage({
						defaultMessage: 'HTJ2 integraatio',
						description: 'Title for HTJ2 integration.',
					})}
				/>
				{pageContent}
			</StandardCard>
		</>
	)
}
export default HTJ2AuthorizationCard
